// 50 Major Global Cities supported by FlameLink
export const supportedCities = [
  // United States - Major Cities
  { name: "New York, NY", region: "Northeast US", population: "8.3M", country: "USA" },
  { name: "East Los Angeles, CA", region: "West Coast US", population: "4.0M", country: "USA" },
  { name: "Chicago, IL", region: "Midwest US", population: "2.7M", country: "USA" },
  { name: "Houston, TX", region: "South US", population: "2.3M", country: "USA" },
  { name: "Phoenix, AZ", region: "Southwest US", population: "1.7M", country: "USA" },
  { name: "Philadelphia, PA", region: "Northeast US", population: "1.6M", country: "USA" },
  { name: "San Antonio, TX", region: "South US", population: "1.5M", country: "USA" },
  { name: "San Diego, CA", region: "West Coast US", population: "1.4M", country: "USA" },
  { name: "Dallas, TX", region: "South US", population: "1.3M", country: "USA" },
  { name: "San Jose, CA", region: "West Coast US", population: "1.0M", country: "USA" },
  { name: "West Los Angeles, CA", region: "West Coast US", population: "15K", country: "USA" },
  { name: "Austin, TX", region: "South US", population: "965K", country: "USA" },
  { name: "Jacksonville, FL", region: "Southeast US", population: "950K", country: "USA" },
  { name: "Fort Worth, TX", region: "South US", population: "935K", country: "USA" },
  { name: "Columbus, OH", region: "Midwest US", population: "905K", country: "USA" },
  { name: "Charlotte, NC", region: "Southeast US", population: "885K", country: "USA" },
  { name: "San Francisco, CA", region: "West Coast US", population: "875K", country: "USA" },
  { name: "Indianapolis, IN", region: "Midwest US", population: "870K", country: "USA" },
  { name: "Seattle, WA", region: "Pacific Northwest US", population: "750K", country: "USA" },
  { name: "Denver, CO", region: "Mountain West US", population: "715K", country: "USA" },
  { name: "Washington, DC", region: "Northeast US", population: "705K", country: "USA" },
  { name: "Boston, MA", region: "Northeast US", population: "695K", country: "USA" },
  { name: "El Paso, TX", region: "Southwest US", population: "680K", country: "USA" },
  { name: "Nashville, TN", region: "South US", population: "670K", country: "USA" },
  { name: "Detroit, MI", region: "Midwest US", population: "670K", country: "USA" },
  { name: "Oklahoma City, OK", region: "South US", population: "695K", country: "USA" },
  { name: "Portland, OR", region: "Pacific Northwest US", population: "650K", country: "USA" },
  { name: "Las Vegas, NV", region: "Southwest US", population: "645K", country: "USA" },
  { name: "Memphis, TN", region: "South US", population: "650K", country: "USA" },
  { name: "Louisville, KY", region: "South US", population: "630K", country: "USA" },
  { name: "Baltimore, MD", region: "Northeast US", population: "595K", country: "USA" },
  { name: "Milwaukee, WI", region: "Midwest US", population: "590K", country: "USA" },
  { name: "Albuquerque, NM", region: "Southwest US", population: "560K", country: "USA" },
  { name: "Tucson, AZ", region: "Southwest US", population: "545K", country: "USA" },
  { name: "Fresno, CA", region: "West Coast US", population: "540K", country: "USA" },
  { name: "Orange County, CA", region: "West Coast US", population: "3.1M", country: "USA" },
  { name: "Sacramento, CA", region: "West Coast US", population: "525K", country: "USA" },
  { name: "Atlanta, GA", region: "Southeast US", population: "500K", country: "USA" },
  { name: "Kansas City, MO", region: "Midwest US", population: "495K", country: "USA" },
  { name: "Colorado Springs, CO", region: "Mountain West US", population: "480K", country: "USA" },
  { name: "Miami, FL", region: "Southeast US", population: "470K", country: "USA" },
  { name: "Raleigh, NC", region: "Southeast US", population: "470K", country: "USA" },
  { name: "Omaha, NE", region: "Midwest US", population: "480K", country: "USA" },

  // Pacific Region (Hawaii, Guam)
  { name: "Honolulu, HI", region: "Pacific", population: "350K", country: "USA" },
  { name: "Maui, HI", region: "Pacific", population: "165K", country: "USA" },
  { name: "Guam", region: "Pacific", population: "170K", country: "USA" },

  // Asia
  { name: "Tokyo, Japan", region: "Asia", population: "14M", country: "Japan" },
  { name: "Seoul, South Korea", region: "Asia", population: "9.7M", country: "South Korea" },
  { name: "Shanghai, China", region: "Asia", population: "24M", country: "China" },
  { name: "Taipei, Taiwan", region: "Asia", population: "2.6M", country: "Taiwan" },

  // Canada
  { name: "Toronto, Canada", region: "Canada", population: "2.9M", country: "Canada" },
  { name: "Vancouver, Canada", region: "Canada", population: "675K", country: "Canada" }
];

// Regions for filtering
export const supportedRegions = [
  "Northeast US",
  "West Coast US", 
  "Midwest US",
  "South US",
  "Southeast US",
  "Southwest US",
  "Pacific Northwest US",
  "Mountain West US",
  "Pacific",
  "Asia", 
  "Canada"
];

// Get cities by region
export const getCitiesByRegion = (region) => {
  return supportedCities.filter(city => city.region === region);
};

// Get all city names
export const getAllCityNames = () => {
  return supportedCities.map(city => city.name);
};

// Check if a city is supported
export const isCitySupported = (cityName) => {
  return supportedCities.some(city => 
    city.name.toLowerCase().includes(cityName.toLowerCase())
  );
};